module.exports = {
      id: "android-small-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#android-small",
      toString: function () {
        return this.url;
      }
    }